module.exports = __webpack_public_path__ + "media/winter_2023_sweepstakes/facebook-social-icon-46b66db5.svg";